// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__33TsM","upload":"Small_upload__2tZ17","imageWrap":"Small_imageWrap__iT-fD","removeBtn":"Small_removeBtn__2c2fR"};